import downloadByFormBuilderFieldId from './downloadByFormBuilderFieldId';
import download from './download';

export default [downloadByFormBuilderFieldId, download];
